<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="1200"
    v-model="dialog"
  >
    <template>
      <v-card v-if="device">
        <v-toolbar
          color="primary"
          dark
        >

          <v-btn
            @click="handleClose"
            style="margin-right: 20px;"
          >Cerrar</v-btn>
          <v-spacer/>
          <v-btn
            @click="handleRefresh"
            style="margin-right: 20px;"
          >
            <v-icon>mdi-sync</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 10px;">
          <v-row>
            <v-col
                cols="12"
                class="d-flex justify-center"
            >
                <div
                    v-if="previewURL"
                    ref="iframeContainer"
                    class="iframe-container"
                >
                    <div
                      :style="{
                        width: `${width * scale}px`,
                        height: `${height * scale}px`,
                        overflow: 'hidden',
                        position: 'relative'
                      }"
                    >
                      <iframe
                        :src="previewURL"
                        :width="width"
                        :height="height"
                        frameborder="0"
                        :style="{
                          transform: `scale(${scale})`,
                          transformOrigin: 'top left', /* Crucial para que no se mueva al centro */
                          position: 'absolute',
                          top: 0,
                          left: 0
                        }"
                      />
                    </div>
                    <!--iframe
                        :src="previewURL"
                        :width="width"
                        :height="height"
                        frameborder="0"
                        :style="{
                          transform: `scale(${scale})`,
                        }"
                    /-->
                </div>
                </v-col>
          </v-row>
        </v-card-text>
        <v-snackbar
          v-model="showAlert"
          :timeout="2000"
        >
          {{ alertMsg }}

          <!--template v-slot:action="{ attrs }">
            <v-btn
              color="blue"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </template-->
        </v-snackbar>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="handleClose"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import apiBrightsign from '@/services/apiBrightsign'
export default {
  props: {
    device: {
      type: Object,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    previewURL: null,
    showAlert: false,
    alertMsg: null,
    screenshots: [],
    loadingScreenshot: false,
    errors: [],
    loading: false,
    loadingGroups: false,
    groups: [],
    width: null,
    height: null,
    scale: 1,
  }),
  computed: {
    token () {
      return localStorage.getItem('jwt')
    },
  },
  watch: {
    device (v) {
      this.dialog = v ? true : false
    },
    'device.Network' () {
      this.handleRefresh()
    },
    showAlert (v) {
      if (!v) this.alertMsg = null
    },
    alertMsg (v) {
      this.showAlert = v ? true : false
    },
  },
  mounted () {
    this.handleRefresh()
    this.$nextTick(() => {
        this.resizeObserver = new ResizeObserver(() => {
          this.calculateScale()
        })

        if (this.$refs.iframeContainer) {
          this.resizeObserver.observe(this.$refs.iframeContainer)
        }

        window.addEventListener('resize', this.calculateScale)
      })
  },

  beforeDestroy () {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }

    window.removeEventListener('resize', this.calculateScale)
  },
  methods: {
    calculateScale () {
        if (!this.width || !this.height) {
          this.scale = 1
          return
        }

        const container = this.$refs.iframeContainer

        if (!container) return

        const availableWidth = container.clientWidth
        const availableHeight = window.innerHeight - 200

        const scaleX = availableWidth / this.width
        const scaleY = availableHeight / this.height

        this.scale = Math.min(scaleX, scaleY, 1)
    },
    handleRefresh () {
      this.previewURL = null
      if (!this.device) return
      apiBrightsign.getItem(`/v1/private/presentations/${this.device.Network}/${this.device.PresentationID}/bs`)
        .then(response => {
          console.log(response)
          this.previewURL = `https://bs-preview.dviewq.com/#/${response.token}`
          this.width = response.width
          this.height = response.height
          this.$nextTick(() => {
            this.calculateScale()
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleClose () {
      this.previewURL = null
      this.onClose()
    },
  },
}
</script>
<style scoped>
.iframe-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.iframe-container iframe {
  border: 0;
  flex-shrink: 0;
}
</style>
